import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'default-password',
    components: {

    },
})

export default class DefaultPassword extends Vue {

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedConfig: any;

    private defaultPWD: any = '';

    // -------------------------------------------------------------------
    // Hooks
    private created() {
        const tenantSettings = this.selectedConfig.tenantConfig;
        if (tenantSettings && tenantSettings.value) {
            this.defaultPWD = tenantSettings.value;
        }
    }

    // ------------------------------------------------------------------
    // Actions

    private onChangeConfig() {
        this.$emit('onChangeConfig', this.defaultPWD);
    }
}
